import React from 'react'
import Page from '../../../../components/Page'
import { errorMessage } from '../../../../hooks/message';
import Swal from 'sweetalert2';
import Service from '../../../../service';
import Datatable from '../../../../components/Datatable';
import { useNavigate } from 'react-router-dom';

const api = Service.getInstance();

function TipoAtividade() {

    const [data, setData] = React.useState([]);

    const navigate = useNavigate();

    const clickUpdate = id => navigate(`/administracao/tipo-atividades/tipo-atividade/${id}`);

    const clickDelete = id => {
        Swal.fire({
            html: `<div className="mb-7">Deseja apagar o registro ${id}?</div>`,
            icon: "question",
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-active-light"
            }
        }).then(function (result) {

            if (result.value) {

                (async () => {

                    try {

                        await api.delete(`tipo-atividades/${id}`)

                        setData(data.filter(element => element.id !== id));

                    } catch (error) {
                        const { statusText, message } = errorMessage(error);
                        Swal.fire({
                            title: statusText,
                            text: message,
                            icon: 'error'
                        })
                    }

                })();

            }
        });
    };

    React.useEffect(() => {

        (async () => {

            try {
                
                const response = await api.get('tipo-atividades')

                setData(response.data);

            } catch (error) {
                const { message } = errorMessage(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: message
                });
            }

        })();

    }, [])

    return (
        <Page title="Tipo de Atividade">
            <Datatable data={data} columns={columns} update={clickUpdate} delete={clickDelete} create='/administracao/tipo-atividades/tipo-atividade' />
        </Page>
    )
}

export default TipoAtividade

const columns = [
    {
        name: "ID",
        selector: row => row["id"],
        sortable: true,
        grow: 2,
        width: "60px"
    },
    {
        name: "Nome",
        selector: row => row["descricao"],
        sortable: true,
        grow: 2,
    },
    {
        name: "Data da criação",
        cell: row => row['created_at'],
        sortable: true,
        grow: 2,
    },
    {
        name: "Data de atualização",
        cell: row => row['updated_at'],
        sortable: true,
        grow: 2,
    }
];